import React, { useRef } from "react";

import css from "./UploadFurnitureXlsxButtonPanel.module.css";
import { Button } from "../components/Button/Button";
import { uploadFurnitureExcel } from "@/api/furniture";

export const UploadFurnitureXlsxButtonPanel: React.FC = () => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleUpload = (file: File) => {
        uploadFurnitureExcel(file);
    };

    return (
        <div className={css.main}>
            <Button
                variant="secondary"
                size="small"
                onClick={() => {
                    inputRef.current?.click();
                }}
            >
                .xls
            </Button>
            <input
                style={{ display: "none" }}
                ref={inputRef}
                type="file"
                accept=".xlsx"
                onChange={(event) => {
                    const file = event.target.files?.[0];
                    if (file) {
                        handleUpload(file);
                    }
                }}
            />
        </div>
    );
};
